import { Route, Routes } from '@angular/router';
import { OrganizationManagementContainerComponent } from './containers/organization-management.container.component';

export const OrganizationManagementRoutes: Routes = [
  {
    path: '',
    children: [
      <Route>{
        path: '',
        component: OrganizationManagementContainerComponent,
      },
    ],
  },
];

